/** 이벤트 관리 어드민이 발행하는 단일 event_config (R2 standalone JSON, 채널별). */
export interface EventDiscountConfig {
  // 신규 (source of truth) — 골드/루비 영역 독립 표기 토글.
  upgradeGold: boolean;
  /** 골드 영역 표시용 할인율(%) — 라벨 전용. */
  upgradeGoldPct: number;
  upgradeRuby: boolean;
  /** 루비 영역 표시용 할인율(%) — 라벨 전용. */
  upgradeRubyPct: number;
  // 레거시 (deprecated) — 기존 발행본 폴백 전용. normalizeUpgradeDiscount 가 흡수.
  upgrade?: boolean;
  upgradePct?: number;
  // 펫 (변경 없음).
  petSapphire: boolean;
  /** 표시용 할인율(%) — 라벨 전용. */
  petSapphirePct: number;
}

export interface EventCompanionTier {
  /** "PET_<숫자펫id>" — reward-key 규약. 표시 메타(등급/이름/태그/썸네일)는 펫 마스터데이터에서 파생. */
  pet_id: string;
  /** 누적 결제 임계($). */
  threshold: number;
}

export interface EventCompanionConfig {
  active: boolean;
  goal: number;
  tiers: EventCompanionTier[];
  endTime?: number;
}

export interface EventMilestoneItem {
  id: number;
  clearCondition: Record<string, number>;
  tier: string;
  displayReward: Record<string, number>;
  titleKey: string;
}

export interface EventMilestonesConfig {
  active: boolean;
  endTime?: number;
  items: EventMilestoneItem[];
}

/** 별 모으기(초기 보상) 이벤트 — 활성 토글 + 종료 시각. 단계·보상은 마스터데이터 퀘스트(isEvent). */
export interface EventStarRewardConfig {
  active: boolean;
  endTime?: number;
}

export interface EventConfig {
  discount: EventDiscountConfig;
  companion: EventCompanionConfig;
  milestones: EventMilestonesConfig;
  starReward: EventStarRewardConfig;
}

/** 미발행/fetch 실패 시 graceful fallback — 전 기능 off. */
export const EMPTY_EVENT_CONFIG: EventConfig = {
  discount: {
    upgradeGold: false,
    upgradeGoldPct: 30,
    upgradeRuby: false,
    upgradeRubyPct: 30,
    petSapphire: false,
    petSapphirePct: 30,
  },
  companion: { active: false, goal: 0, tiers: [] },
  milestones: { active: false, items: [] },
  starReward: { active: false },
};
